import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogActions, DialogContent, IconButton, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  searchName: string;

  handleClose(): void;

  handleCloseAndProceed(): void;
}

const AddMoreSearchesDialog: React.FC<Props> = ({ open, searchName, handleClose, handleCloseAndProceed }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Dialog open={open} classes={{ paper: classes.paper }} fullWidth maxWidth={'sm'}>
      <DialogContent className={classes.content}>
        <IconButton size={'small'} sx={{ position: 'absolute', top: '8px', right: '8px' }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
        <Typography className={classes.greyText}>
          <Trans i18nKey={'addMoreSearchesInstruction'} values={{ searchName }}>
            You have successfully added the search <span className={classes.regularText}>{searchName}</span>. To add more searches, click the
            &quot;Add More Searches&quot; button. Once you&apos;re ready, click &quot;Review leads&quot; to proceed.
          </Trans>
        </Typography>
      </DialogContent>
      <DialogActions className={classes.actions}>
        <PaiLink text={t('addMoreSearches')} size={'lg'} underline={'always'} action={handleClose} />
        <PaiButton text={t('reviewContacts')} border={'rounded'} size={'small'} action={handleCloseAndProceed} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: '16px',
  },
  content: {
    padding: '32px !important',
    whiteSpace: 'pre-wrap',
    position: 'relative',
  },
  greyText: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.greys.medium,
  },
  regularText: {
    color: theme.palette.text.primary,
    fontWeight: 'bold',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '16px',
    padding: '0 24px 20px 24px',
  },
}));

export default AddMoreSearchesDialog;
